module.exports = __webpack_public_path__ + "img/field.2fe3e3bd.jpg";